import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { BankAccountType } from '@/modules/asset/enums/BankAccountType';
import { FinalTaxesAsset } from '@/modules/tax/models/finaltaxescalculator/FinalTaxesAsset';

export class FinalTaxesBankAccountAsset extends FinalTaxesAsset {
  type?: string;
  marketValue?: number;
  rollOver?: boolean;

  constructor(model: Partial<FinalTaxesBankAccountAsset> = {}) {
    super(model);

    this.type = model.type ?? '';
    this.marketValue = model.marketValue ?? 0;
    this.rollOver = model.rollOver ?? false;
  }

  getModelName(): ModelType {
    return ModelType.FINAL_TAXES_BANK_ACCOUNT_ASSET;
  }

  get formattedType(): string {
    return BankAccountType.getByKey(this.type)?.value ?? '';
  }
}
